/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'avi-dropdown-menu';
const prefix = `${moduleName}.${componentName}`;

export const searchPlaceholderLabel = `${prefix}.searchPlaceholderLabel`;

export const ENGLISH = {
    [searchPlaceholderLabel]: 'Search',
};
